import React from "react";
import {
  AvatarStyle,
  AvatarWrapper,
  SpanStyle,
  UserInfo,
} from "./Avatar.style";

interface Avatarprops {
  icon?: React.ReactNode;
  children?: string;
  size?:
    | "large"
    | "small"
    | "default"
    | number
    | Partial<Record<"xxl" | "xl" | "lg" | "md" | "sm" | "xs", number>>;
  shape?: "circle" | "square";
  src?: React.ReactNode;
  alt?: string;
  username?: string;
  useremail?: string;
  onClick?: () => void;
}

const Avatar = (props: Avatarprops) => {
  const {
    size,
    shape,
    icon,
    src,
    alt,
    username,
    useremail,
    children,
    onClick,
  } = props;
  return (
    <AvatarWrapper>
      <AvatarStyle
        icon={icon}
        size={size}
        shape={shape}
        src={src}
        alt={alt}
        onClick={onClick}
      />
      {children}
      {username || useremail ? (
        <UserInfo>
          {username && <h6 className="username">{username}</h6>}
          {useremail && (
            <SpanStyle className="useremail">{useremail}</SpanStyle>
          )}
        </UserInfo>
      ) : (
        ""
      )}
    </AvatarWrapper>
  );
};

export default Avatar;
